import React, { useEffect, useMemo, useState } from 'react';

const msInMinute = 60 * 1000;
const msInHour = 60 * msInMinute;
const msInDay = 24 * msInHour;

const Countdown = () => {
  const target = useMemo(() => new Date(2026, 3, 27, 0, 0, 0).getTime(), []);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(target - now, 0);
  const days = Math.floor(diff / msInDay);
  const hours = Math.floor((diff % msInDay) / msInHour);
  const minutes = Math.floor((diff % msInHour) / msInMinute);

  const pad = (n) => String(n).padStart(2, '0');

  return (
    <section className="countdown">
      <div className="container countdown-inner">
        <div className="countdown-item">
          <div className="countdown-value">{days}</div>
          <div className="countdown-label">Days</div>
        </div>
        <div className="countdown-sep">:</div>
        <div className="countdown-item">
          <div className="countdown-value">{pad(hours)}</div>
          <div className="countdown-label">Hours</div>
        </div>
        <div className="countdown-sep">:</div>
        <div className="countdown-item">
          <div className="countdown-value">{pad(minutes)}</div>
          <div className="countdown-label">Minutes</div>
        </div>
      </div>
      <div className="container">
        <div className="countdown-note">till EP release</div>
      </div>
    </section>
  );
};

export default Countdown;
